import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';
import { Grid, Typography, Box } from '@material-ui/core';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'on_web/components/shared/Common/Button';
import { shareIllustration } from 'on_web/assets/imageList';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { share } from 'on_web/helpers/shareHelper';
import { COOL_BLUE } from 'colours';

export default function ShareAppPage(props) {
  const { t } = useTranslation();
  const [isDesktop] = useCheckScreenSize();
  const [copied, setCopied] = useState(false);

  const useStyles = makeStyles(theme => ({
    title: {
      paddingTop: '70px',
    },
    subTitle: {
      paddingTop: isDesktop ? '20px' : '30px',
      textTransform: 'uppercase',
    },
    list: {
      paddingBottom: '10px',
      wordWrap: 'break-word',
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    trackEvent('Viewed Share Screen', 'User viewed share screen');
  }, []);

  const saveToClipboard = content => {
    try {
      navigator.clipboard.writeText(content);
      setCopied(true);
    } catch (e) {}
  };

  return (
    <AssessmentPage
      headerMenuText={t('common.menu.mainItems.shareApp')}
      bottomMenuSelectedOptionCode={'share-app'}
      desktopMenuIndex={8}
      secondaryHeaderWithBackNavigation={true}
    >
      <Grid container direction={'column'} justify="center">
        <Grid item xs={12}>
          <Box
            className={classes.subTitle}
            display={'block'}
            textAlign={'center'}
          >
            <Typography
              variant={'h2'}
              style={{ fontSize: isDesktop ? '30px' : '22px' }}
            >
              {t('reporting.share.title')}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box
            mx={'17px'}
            className={isDesktop ? classes.textDesktop : classes.textMobile}
            display={'block'}
            textAlign={'center'}
            style={{ paddingTop: '11px' }}
          >
            <Typography
              variant={'body1'}
              style={{ textAlign: 'center', color: '#222222' }}
            >
              {t('reporting.share.paragraph')}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box display={'block'} textAlign={'center'}>
            <img
              src={shareIllustration}
              alt="Share illustration"
              style={{ maxWidth: '450px' }}
            />
          </Box>
          <Box
            justify="center"
            textAlign="center"
            style={{ paddingTop: isDesktop ? '26px' : '20px' }}
          >
            <Button
              variant="contained"
              color="primary"
              backgroundGradient={'linear-gradient(to right, #194378, #30eaff)'}
              style={{
                paddingLeft: '25px',
                paddingRight: '25px',
                paddingTop: '10px',
                paddingBottom: '10px',
                textTransform: 'uppercase',
              }}
              onClick={() => share(t)}
            >
              {t('reporting.share.sendInvitation')}
            </Button>
          </Box>
          <Box
            mx={'17px'}
            display={'block'}
            textAlign={'center'}
            style={{
              paddingTop: isDesktop ? '26px' : '20px',
            }}
          >
            <Typography
              variant={'body1'}
              style={{ textAlign: 'center', color: '#222222' }}
            >
              {t('reporting.share.linkInstructions')}
            </Typography>
          </Box>
          <Box
            mx={'17px'}
            display={'block'}
            textAlign={'center'}
            style={{
              paddingTop: isDesktop ? '26px' : '20px',
              marginBottom: isDesktop ? '0' : '80px',
            }}
          >
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Typography
                  variant={'body1'}
                  style={{ textAlign: 'center', color: '#222222' }}
                >
                  <div
                    style={{
                      border: '1px Solid #ececec',
                      paddingTop: '5px',
                      paddingBottom: '5px',
                      paddingLeft: '40px',
                      paddingRight: '40px',
                      borderRadius: '20px',
                    }}
                  >
                    <span>{t('reporting.share.link')}</span>
                  </div>
                </Typography>
              </Grid>
              <Grid
                item
                style={{ marginLeft: '10px', cursor: 'pointer' }}
                onClick={() => {
                  saveToClipboard(t('reporting.share.linkFull'));
                }}
              >
                <Typography
                  variant={'body1'}
                  style={{
                    textAlign: 'center',
                    color: copied ? 'Green' : COOL_BLUE,
                  }}
                >
                  {copied ? 'Copied' : 'Copy'}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </AssessmentPage>
  );
}
